/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataWebsitImageConfigInfoRespVo } from './PageDataWebsitImageConfigInfoRespVo';
import {
    PageDataWebsitImageConfigInfoRespVoFromJSON,
    PageDataWebsitImageConfigInfoRespVoFromJSONTyped,
    PageDataWebsitImageConfigInfoRespVoToJSON,
    PageDataWebsitImageConfigInfoRespVoToJSONTyped,
} from './PageDataWebsitImageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataWebsitImageConfigInfoRespVo
 */
export interface ResponsePageDataWebsitImageConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataWebsitImageConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataWebsitImageConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataWebsitImageConfigInfoRespVo}
     * @memberof ResponsePageDataWebsitImageConfigInfoRespVo
     */
    data?: PageDataWebsitImageConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataWebsitImageConfigInfoRespVo interface.
 */
export function instanceOfResponsePageDataWebsitImageConfigInfoRespVo(value: object): value is ResponsePageDataWebsitImageConfigInfoRespVo {
    return true;
}

export function ResponsePageDataWebsitImageConfigInfoRespVoFromJSON(json: any): ResponsePageDataWebsitImageConfigInfoRespVo {
    return ResponsePageDataWebsitImageConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataWebsitImageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataWebsitImageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataWebsitImageConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataWebsitImageConfigInfoRespVoToJSON(json: any): ResponsePageDataWebsitImageConfigInfoRespVo {
    return ResponsePageDataWebsitImageConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataWebsitImageConfigInfoRespVoToJSONTyped(value?: ResponsePageDataWebsitImageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataWebsitImageConfigInfoRespVoToJSON(value['data']),
    };
}

